import { compose } from 'recompose';

import TextAreaView from './TextAreaView';

export default compose()(TextAreaView);
